import React, {useState} from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import {Alert, Card, Col, Container, Row} from "react-bootstrap";
import {Formik} from "formik";
import * as formik from "formik";
import * as yup from "yup";
import {authApi} from "../../api/auth.js";
import bctcLogo from "../../images/BCTC_Logo_Horiz_small.png";

function ForgotPasswordPage() {
    const { Formik } = formik;
    const schema = yup.object().shape({
        email: yup.string().email('Invalid email format').required(),
    });

    const [pageState, setPageState] = useState({pageError: null, submitted: false});

    return (
        <div className="auth-shell">
            <Container style={{maxWidth: 680}}>
                <Card className="auth-card p-4 mx-auto">
                    <div className="auth-header">
                        <img src={bctcLogo} height="64" alt="BCTC logo" />
                        <h1 className="auth-title">Forgot Password</h1>
                        <p className="auth-subtitle">Enter your email and we’ll send a reset link.</p>
                    </div>
                    {pageState.pageError && (
                        <Alert key="pageError" variant="danger">
                            {pageState.pageError}
                        </Alert>
                    )}
                    {pageState.submitted ? (
                        <p className="mb-0">
                            If the email exists, a reset link is on its way. The link is valid for 24 hours.
                        </p>
                    ) : (
                        <Row className="justify-content-center">
                            <Col md={10}>
                                <Formik
                                    validationSchema={schema}
                                    onSubmit={async (values, { setSubmitting }) => {
                                        try {
                                            setSubmitting(true);
                                            await authApi.sendPasswordResetLink(values.email);
                                            setPageState(prevState => ({...prevState, submitted: true, pageError: null}));
                                        } catch (e){
                                            setPageState(prevState => ({...prevState, pageError: "We couldn’t process your request. Please try again."}));
                                            console.error(e);
                                        } finally {
                                            setSubmitting(false);
                                        }
                                    }}
                                    initialValues={{
                                        email: "",
                                    }}
                                >
                                    {({ handleSubmit, handleChange, touched, values, isSubmitting, errors }) => (
                                        <Form noValidate onSubmit={handleSubmit}>
                                            <Form.Group className="mb-3" controlId="email">
                                                <Form.Label className="text-center d-block">
                                                    Email address
                                                </Form.Label>
                                                <Form.Control
                                                    name="email"
                                                    onChange={handleChange}
                                                    value={values.email}
                                                    type="email"
                                                    placeholder="you@example.com"
                                                    isInvalid={touched.email && !!errors.email}
                                                />
                                                {touched.email && (<Form.Control.Feedback type="invalid">
                                                    {errors.email}
                                                </Form.Control.Feedback>)}
                                            </Form.Group>
                                            <Row className="g-2">
                                                <Col xs={12} md={6}>
                                                    <div className="d-grid">
                                                        <Button type="submit" disabled={isSubmitting}>
                                                            Send reset link
                                                        </Button>
                                                    </div>
                                                </Col>
                                                <Col xs={12} md={6}>
                                                    <div className="d-grid">
                                                        <Button variant="outline-secondary" onClick={() => window.location.href = '/login'}>
                                                            Cancel
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Form>
                                    )}
                                </Formik>
                            </Col>
                        </Row>
                    )}
                </Card>
            </Container>
        </div>
    );
}

export default ForgotPasswordPage
